import React from 'react';
import ManageDepartmentForm from '../Forms/manage_department_form';
import { ManageDataPage } from './manageDataShared';

const COLUMNS = [
    { label: 'Name', field: 'Name' },
];

function Manage_department() {
    return (
        <ManageDataPage
            title="Manage Department"
            endpoint="get_manage_department_table"
            columns={COLUMNS}
            idKey="DepartmentID"
            FormComponent={ManageDepartmentForm}
            searchPlaceholder="Search department..."
        />
    );
}

export default Manage_department;
